import {
  Menu, MenuButton, IconButton, MenuList, MenuButtonProps, MenuProps, Portal,
} from "@chakra-ui/react";
import { PropsWithChildren } from "react";
import { IconType } from "react-icons";

interface IconMenuProps extends PropsWithChildren, MenuButtonProps {
  icon: IconType;
  ariaLabel: string;
  menuFontSize?: MenuListProps["fontSize"];
  menuProps?: Omit<MenuProps, "children">;
  inPortal?: boolean;
}

export default function IconMenu({
  icon: Icon, ariaLabel, inPortal = false, children, menuFontSize, menuProps = {}, ...rest
}: IconMenuProps) {
  return (
    <Menu {...menuProps}>
      <MenuButton
        color="chakra-subtle-text"
        _hover={{ color: "chakra-placeholder-color" }}
        as={IconButton}
        aria-label={ariaLabel}
        icon={<Icon />}
        variant="unstyled"
        {...rest}
      />
      {inPortal ? (
        <Portal>
          <MenuList fontSize={menuFontSize}>{children}</MenuList>
        </Portal>
      ) : (
        <MenuList fontSize={menuFontSize}>{children}</MenuList>
      )}
    </Menu>
  );
}
